const listed_property_reducer = (state = "", action) => {
	switch(action.type) {

		case 'SETLISTEDPROPERTY':
			return action.payload;

		default:
			return state;
	}
}

export default listed_property_reducer;